import React from "react";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";
Highcharts.setOptions({
    plotOptions: {
        series: {
            animation: false,
        },
    },
    lang: {
        thousandsSep: ",",
    },
    credits: false,
});
HighchartsMore(Highcharts);
var ChartType8 = function (props) {
    var values = props.values, titles = props.titles, colors = props.colors, prefix = props.prefix, postfix = props.postfix, custom_options = props.custom_options;
    var symbol = prefix || "";
    var sign = postfix || "";
    var options = {
        chart: {
            type: "waterfall",
            height: "490px",
        },
        lineWidth: 0,
        title: {
            text: "",
        },
        xAxis: {
            type: "category",
            categories: [
                "Win more<br/>deals",
                "Prevent<br/>slipped<br/>deals",
                "Increased<br/>sales<br/>productivity",
                "Retain<br/>more<br/>customers",
                "Expand<br/>existing<br/>customers",
                "Estimated<br/>revenue<br/>leak",
            ],
            labels: {
                enabled: true,
                style: {
                    fontWeight: 400,
                    fontSize: "11px",
                },
            },
        },
        yAxis: {
            title: {
                text: "",
            },
            gridLineColor: "#ffffff",
            gridLineWidth: 0,
            labels: {
                enabled: false,
            },
        },
        legend: {
            enabled: false,
        },
        tooltip: {
            pointFormat: "<b>" + symbol + "{point.y:,.0f} " + sign + "</b>",
        },
        series: [
            {
                data: [
                    {
                        name: "Win more deals",
                        y: 12,
                        color: "#24DAB8",
                    },
                    {
                        name: "Prevent slipped deals",
                        y: 321,
                        color: "#80BFFF",
                    },
                    {
                        name: "Increased sales productivity",
                        y: 212,
                        color: "#5E25D7",
                    },
                    {
                        name: "Retain more customers",
                        y: 123,
                        color: "#282829",
                    },
                    {
                        name: "Expand existing customers",
                        y: 123,
                        color: "#282829",
                    },
                    {
                        name: "Estimated revenue leak",
                        y: 231,
                        color: "#0E7AFF",
                    },
                ],
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return (symbol + "" + Highcharts.numberFormat(this.y, 1, ".") + "" + sign);
                    },
                    style: {
                        fontWeight: "bold",
                    },
                },
                pointPadding: 0,
                lineWidth: 0,
            },
        ],
    };
    if (values && values.length > 0) {
        var data_1 = [];
        values.map(function (value, i) {
            data_1.push({
                name: (titles && titles[i]) || i,
                y: value,
                color: (colors && colors[i]) || "",
            });
        });
        options.series = [
            {
                data: data_1,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return (symbol + "" + Highcharts.numberFormat(this.y, 1, ".") + "" + sign);
                    },
                    style: {
                        fontWeight: "bold",
                    },
                },
                pointPadding: 0,
                lineWidth: 0,
            },
        ];
    }
    if (titles && titles.length > 0) {
        options.xAxis.categories = titles;
    }
    var HandleObject = function (object, new_options) {
        Object.keys(object).map(function (e) {
            if (Object.keys(object[e]).length > 0 && typeof object[e] === "object") {
                HandleObject(object[e], new_options[e]);
            }
            else {
                new_options[e] = object[e];
            }
        });
    };
    if (custom_options) {
        if (Object.keys(custom_options).length > 0) {
            Object.keys(custom_options).map(function (e) {
                if (Object.keys(custom_options[e]).length > 0 &&
                    typeof custom_options[e] === "object") {
                    HandleObject(custom_options[e], options[e]);
                }
                else {
                    options[e] = custom_options[e];
                }
            });
        }
    }
    if (props.debug_mood) {
        console.log("high chart debug mood", options);
    }
    return (React.createElement("div", null,
        React.createElement(HighchartsReact, { highcharts: Highcharts, options: options })));
};
export default ChartType8;
